import api from 'api';
import { useEffect, useState, useContext, useRef } from 'react';
import { USDollar } from 'utils/format';
import _ from 'lodash';
import { Spin, message } from 'antd';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import {
    getTodayDateString,
    isPhoneSize,
    isAdmin,
    sendEmail,
    getTomorrow,
    isVAFull,
} from 'utils/util';
import './PayoutSummary.css';
import { SummaryFilter } from './SummaryFilter';
import { GlobalContext } from 'GlobalContext';
import { PrincipalSumErrorConfirmation } from 'ConfirmationPages/PrincipalSumErrorConfirmation';
import { CloseInvestmentConfirmation } from 'ConfirmationPages/CloseInvestmentConfirmation';
import { get } from 'utils/fetch';
import { AccountDetail } from './AccountDetail';
import { Default } from './Views/Default';
import {
    Accounting,
    AccountingHeader,
    AccountingSummary,
} from './Views/Accounting/Accounting';
import { useLocation } from 'react-router-dom';
import { NoticeEmail } from 'pages/Email/NoticeEmail';
import { EmailResultBox } from 'pages/Email/EmailResultBox';
import { exportPayoutSummary } from './util';

export function PayoutSummary(props) {
    const {
        accessToken,
        payoutsRaw,
        setPayoutsRaw,
        filters,
        setFilters,
        tableView,
        setTableView,
        refreshSession,
        emailNoticeTransactionId,
        setEmailNoticeTransactionId,
    } = useContext(GlobalContext);
    const [startDate, setStartDate] = useState(getTodayDateString());
    const [endDate, setEndDate] = useState(getTodayDateString());
    // const [payoutsRaw, setPayoutsRaw] = useState([]);
    const [payouts, setPayouts] = useState({});
    const [investorId2name, setInvestorId2name] = useState({});
    const [investorId2email, setInvestorId2email] = useState({});

    const [transactionId2Status, setTransactionId2Status] = useState({});
    const [accountId2Investors, setAccountId2Investors] = useState({});
    const [loading, setLoading] = useState(false);
    const [uiMessage, setUiMessage] = useState('');
    const [totalInterestAmount, setTotalInterestAmount] = useState(0);
    const [filterIsOpen, setFilterIsOpen] = useState(false);
    const [showErrorbox, setShowErrorbox] = useState(false);
    const [showCloseConfirmationBox, setShowCloseConfirmationBox] =
        useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [curInvestmentIdBeingModified, setCurInvestmentIdBeingModified] =
        useState(-1);
    const [funds, setFunds] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [accountIdToView, setAccountIdToView] = useState(-1);
    const [accountId2accountName, setAccountId2accountName] = useState({});

    const timezoneOffset = 'T00:00:00-07:00';
    const accountingScrollRef = useRef(null);
    const topScrollRef = useRef(null); // the "asdasdsadasdsa" scrollable
    const SummaryScrollRef = useRef(null);
    const location = useLocation();
    const [accountId2Currency, setAccountId2Currency] = useState({});
    const [curPaymentState, setCurPaymentState] = useState(''); // paid or unpaid for current transaction action
    // id of the transaction that the email is about, replaced by setEmailNoticeTransactionId
    // const [curTransactionId, setCurTransactionId] = useState(-1)
    const [curTransactionType, setCurTransactionType] = useState('');
    const [emailResponse, setEmailResponse] = useState('');
    // when close email interface, reset transactionType, emailNoticeTransactionId
    function resetState() {
        setEmailNoticeTransactionId(-1);
        setCurTransactionType('');
        setCurPaymentState('');
    }

    useEffect(() => {
        const accountingEl = accountingScrollRef.current;
        const topEl = topScrollRef.current;

        if (!accountingEl || !topEl) return;

        const syncScroll = (source, target) => {
            return () => {
                target.scrollLeft = source.scrollLeft;
            };
        };

        // Add listeners to sync both ways if needed
        accountingEl.addEventListener(
            'scroll',
            syncScroll(accountingEl, topEl)
        );
        topEl.addEventListener('scroll', syncScroll(topEl, accountingEl));

        return () => {
            accountingEl.removeEventListener(
                'scroll',
                syncScroll(accountingEl, topEl)
            );
            topEl.removeEventListener(
                'scroll',
                syncScroll(topEl, accountingEl)
            );
        };
    }, [loading, tableView]);

    useEffect(() => {
        const accountingEl = accountingScrollRef.current;
        const bottomEl = SummaryScrollRef.current;

        if (!accountingEl || !bottomEl) return;

        const syncScroll = (source, target) => {
            return () => {
                target.scrollLeft = source.scrollLeft;
            };
        };

        // Add listeners to sync both ways if needed
        accountingEl.addEventListener(
            'scroll',
            syncScroll(accountingEl, bottomEl)
        );
        bottomEl.addEventListener('scroll', syncScroll(bottomEl, accountingEl));

        return () => {
            accountingEl.removeEventListener(
                'scroll',
                syncScroll(accountingEl, bottomEl)
            );
            bottomEl.removeEventListener(
                'scroll',
                syncScroll(bottomEl, accountingEl)
            );
        };
    }, [loading, tableView]);

    useEffect(() => {
        const data = payoutsRaw;
        // console.log(data)
        var investorId2name = {};
        var investorId2email = {};
        var accountId2Investors = {};
        var totalInterestAmount = 0;
        for (const entry of data) {
            // get sum of interet amount
            totalInterestAmount += entry.transaction_amount;
            accountId2Investors[entry.account_id] = entry.investors;
            for (const investor of entry['investors']) {
                investorId2name[investor.investor_id] = investor.legal_name;
                investorId2email[investor.investor_id] = investor.email;
            }
        }
        setAccountId2Investors(accountId2Investors);
        setTotalInterestAmount(totalInterestAmount);
        setInvestorId2name(investorId2name);
        setInvestorId2email(investorId2email);

        var accountId2accountName = {};
        var accountId2Currency = {};
        for (const entry of data) {
            accountId2accountName[entry.account_id] = entry.account_name;
            accountId2Currency[entry.account_id] = entry.currency;
        }
        setAccountId2accountName(accountId2accountName);
        setAccountId2Currency(accountId2Currency);
        var groupByAccount = {};
        for (const entry of data) {
            if (!groupByAccount[entry.account_id]) {
                groupByAccount[entry.account_id] = [];
            }
            groupByAccount[entry.account_id].push(entry);
        }
        setPayouts(groupByAccount);

        var transactionId2Status = {};
        for (const entry of data) {
            transactionId2Status[entry.transaction_id] =
                entry.transaction_status;
        }
        setTransactionId2Status(transactionId2Status);
        // console.log(groupByAccount)
        setLoading(false);
    }, [payoutsRaw]);

    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    async function fetchFunds() {
        await get(
            api.manager.funds,
            setFunds,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchCompanies() {
        await get(
            api.manager.holdingCompanies,
            setCompanies,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    useEffect(() => {
        if (!accessToken) return;
        fetchFunds();
        fetchCompanies();
    }, [accessToken]);

    async function fetchActiveTransactions() {
        const res = await fetch(api.transaction.activeTransactions, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({
                filters,
            }),
        });
        refreshSession();
        const data = (await res.json()).data;
        setPayoutsRaw(data);

        if (data.length === 0) {
            setUiMessage('No records were found for the specified period.');
        } else {
            setUiMessage(`${data.length} records are displayed above.`);
        }
    }

    async function handleStatusChange(transaction, email, name, type) {
        if (!isAdmin()) return;
        setCurInvestmentIdBeingModified(transaction.investment_id);
        const updatedStatus =
            transactionId2Status[transaction.transaction_id].toLowerCase() ===
            'unpaid'
                ? 'paid'
                : 'unpaid';
        const response = await fetch(
            api.transaction.setStatus(transaction.transaction_id),
            {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({
                    status: updatedStatus,
                }),
            }
        );
        refreshSession();
        // # unpaid entry
        const data = await response.json();
        const unpaidEntryCount = data.data;
        // console.log('unpaidEntryCount', unpaidEntryCount);
        if (unpaidEntryCount === -2) {
            // update status failed, don't update ui status and don't send email
            return;
        }

        const newMap = { ...transactionId2Status };
        // Update the investment value for the investor
        newMap[transaction.transaction_id] = updatedStatus;
        // Set the new map in the state
        setTransactionId2Status(newMap);
        // sendEmail(
        //     updatedStatus === 'paid' ? 'Pay' : 'Unpay',
        //     transaction.transaction_amount,
        //     email,
        //     name,
        //     type.toLowerCase()
        // );
        if (unpaidEntryCount >= 0) {
            // sendEmail(updatedStatus === "paid" ? "Pay" : "Unpay", transaction.amount, email, name, type);
            // send email
            if (
                updatedStatus === 'paid' &&
                (transaction.transaction_type.toLowerCase() === 'interest' ||
                    transaction.transaction_type.toLowerCase() ===
                        'final payout')
            ) {
                // send notice
                setCurPaymentState(updatedStatus); // paid or unpaid for current transaction action
                setEmailNoticeTransactionId(transaction.transaction_id); // id of the transaction that the email is about
                setCurTransactionType(
                    transaction.transaction_type.toLowerCase()
                );
            }
        }

        if (unpaidEntryCount === 0) {
            // pop up prompt to close investment
            setShowCloseConfirmationBox(true);
        } else if (unpaidEntryCount === -1) {
            // error in summation of principals
            // pop up prompt to contact developer
            setShowErrorbox(true);
        }
    }

    function closeInvestmentCallback() {
        fetch(api.manager.closeInvestment(curInvestmentIdBeingModified), {
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        });
    }
    refreshSession();
    // console.log(accountIdToView);
    document.addEventListener('click', () => setFilterIsOpen(false));

    function getSummary() {
        setUiMessage('');
        setLoading(true);
        fetchActiveTransactions();
    }

    const backgroundColors = ['#f5f5f5', '#e9f0f8'];
    const panelBackgroundColor = '#e0e0e0';

    const content = (
        <div style={{ height: '100vh' }}>
            {showCloseConfirmationBox && (
                <CloseInvestmentConfirmation
                    setShowCloseConfirmationBox={setShowCloseConfirmationBox}
                    closeInvestmentCallback={closeInvestmentCallback}
                />
            )}

            {emailResponse && <EmailResultBox emailResponse={emailResponse} />}
            {emailNoticeTransactionId >= 0 && (
                <NoticeEmail
                    setEmailResponse={setEmailResponse}
                    transactionId={emailNoticeTransactionId}
                    transactionType={curTransactionType}
                    resetState={resetState}
                />
            )}

            {showErrorbox && (
                <PrincipalSumErrorConfirmation
                    setShowErrorbox={setShowErrorbox}
                />
            )}
            <AccountDetail
                accountId={accountIdToView}
                setAccountId={setAccountIdToView}
            />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginBottom: '',
                }}
            >
                {filterIsOpen && (
                    <SummaryFilter
                        setFilterIsOpen={setFilterIsOpen}
                        filters={filters}
                        setFilters={setFilters}
                        funds={funds}
                        companies={companies}
                        tableView={tableView}
                        setTableView={setTableView}
                    />
                )}
                <div
                    style={{ display: 'flex', cursor: 'pointer' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        setFilterIsOpen(!filterIsOpen);
                    }}
                >
                    <div>Filters</div>
                    <div>
                        {/* Add rotation based on `isOpen` state */}
                        <span
                            className={`caret-icon ${
                                filterIsOpen ? 'rotate-up' : 'rotate-down'
                            }`}
                        >
                            <CaretDownOutlined />
                        </span>
                    </div>
                </div>

                <button
                    style={{
                        background: 'rgb(17 32 86)',
                        color: 'white',
                        borderRadius: '10px',
                        marginLeft: '10px',
                    }}
                    onClick={() => getSummary()}
                >
                    {'Get Summary'}
                </button>

                {payoutsRaw.length > 0 && (
                    <button
                        style={{
                            background: 'rgb(17 32 86)',
                            color: 'white',
                            borderRadius: '10px',
                            marginLeft: '10px',
                        }}
                        onClick={() =>
                            exportPayoutSummary(payouts, transactionId2Status)
                        }
                    >
                        {'Export'}
                    </button>
                )}
            </div>

            {!loading &&
                tableView === 'accounting' &&
                payoutsRaw.length > 0 && (
                    <div
                        style={{
                            overflowX: 'auto', // make horizontal scrollable
                        }}
                    >
                        <div
                            ref={topScrollRef}
                            style={{
                                overflowX: 'auto',
                                scrollbarWidth: 'none',
                                borderRadius: '8px 8px 0 0',
                                background: panelBackgroundColor,
                            }}
                        >
                            <AccountingHeader />
                        </div>

                        <div>
                            <Accounting
                                payoutsRaw={payoutsRaw}
                                payouts={payouts}
                                accountId2accountName={accountId2accountName}
                                accountId2Investors={accountId2Investors}
                                scrollSyncRef={accountingScrollRef}
                                transactionId2Status={transactionId2Status}
                                timezoneOffset={timezoneOffset}
                                handleStatusChange={handleStatusChange}
                                accountId2Currency={accountId2Currency}
                                backgroundColors={backgroundColors}
                            />
                        </div>

                        <div
                            ref={SummaryScrollRef}
                            style={{
                                overflowX: 'auto',
                                scrollbarWidth: 'none',
                                background: panelBackgroundColor,
                            }}
                        >
                            <AccountingSummary
                                totalInterestAmount={totalInterestAmount}
                                panelBackgroundColor={panelBackgroundColor}
                            />
                        </div>
                    </div>
                )}

            {!loading && tableView === 'default' && payoutsRaw.length > 0 && (
                <div style={{}}>
                    <Default
                        payoutsRaw={payoutsRaw}
                        payouts={payouts}
                        accountId2accountName={accountId2accountName}
                        setAccountIdToView={setAccountIdToView}
                        accountId2Investors={accountId2Investors}
                        transactionId2Status={transactionId2Status}
                        timezoneOffset={timezoneOffset}
                        handleStatusChange={handleStatusChange}
                        totalInterestAmount={totalInterestAmount}
                        loading={loading}
                        tableView={tableView}
                        accountId2Currency={accountId2Currency}
                        backgroundColors={backgroundColors}
                        panelBackgroundColor={panelBackgroundColor}
                    />
                </div>
            )}

            {/* {!loading && tableView === "accounting" && payoutsRaw.length > 0 && <div>asdasdsadasdsa</div>} */}

            {loading && (
                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <Spin />
                </div>
            )}
            {!loading && <div>{uiMessage}</div>}
        </div>
    );
    function canView() {
        return isAdmin() || isVAFull();
    }
    return (
        <>
            {!canView() && <>Not authorized</>}
            {canView() && content}
        </>
    );
}
